import * as yup from 'yup';

export const schema = yup
  .object({
    cod_pessoa: yup.object().required(),
  })
  .required();
